import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridColumn } from '../grid-control.model';
@Pipe({
  name: 'cellDesktopClassName'
})
export class CellDesktopClassNamePipe implements PipeTransform {
  transform(value: any, rowData: GridItem, column: GridColumn, isChildren?: boolean): string {
    const classNames = [];
    if (column.click) {
      classNames.push('cursor-pointer');
    }
    if (isChildren) {
      classNames.push('c-children');
    }
    if (column.badge) {
      const badge = column.badge(rowData, value);
      if (badge) {
        classNames.push('c-badge');
        classNames.push('badge');
        if (badge === 'PRIMARY') {
          classNames.push('badge-primary');
        } else if (badge === 'SECONDARY') {
          classNames.push('badge-secondary');
        } else if (badge === 'WARNING') {
          classNames.push('badge-warning');
        } else if (badge === 'SUCCESS') {
          classNames.push('badge-success');
        } else if (badge === 'DANGER') {
          classNames.push('badge-danger');
        } else if (badge === 'LIGHT') {
          classNames.push('badge-light');
        } else if (badge === 'DARK') {
          classNames.push('badge-dark');
        }
      }
    }
    return classNames.join(' ');
  }
}
